import singles$ from './singles';
import imageParamsExtractor from '../imageParamsExtractor';
import createServiceObservables from './createServiceObservable';

const observables = createServiceObservables(
    'params',
    singles$,
    (single) => imageParamsExtractor.extract(
        single.photo.file,
        500,
        { width: 1920, height: 1080 },
        single.photo.watermark,
        single.photo.signal,
    ),
);

const paramsWithErrors$ = observables.withErrors$;
const paramErrors$ = observables.errorsOnly$;
const params$ = observables.withoutErrors$;

export { paramsWithErrors$, paramErrors$ };
export default params$;
